/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-unused-vars: 0, no-use-before-define: 0, no-var: 0 */
/* globals _, mp */

/**
 * This file includes two classes: DateRange and RelativeDate
 *
 * NOTE: Currently neither class supports hour/minute/second
 *
 * @requires date.js
 * @requires mp.utility
 */

(function() {
  var localize_date = mp.utility.to_localized_date;
  var default_date_format = mp.utility.default_date_format;

  /**
     * Converts a RelativeDate to a Date if needed
     */
  function to_date(date) {
    if (date instanceof RelativeDate) {
      date = date.to_date();
    }
    if (date instanceof Date) {
      date.setHours(0, 0, 0, 0); // remove time
    }
    return date;
  }

  /**
     *  Constructor accepts either a Date instance or the number of days
     *  from today the RelativeDate should represent. If passing a Date,
     *  it must already be localized.
     *
     *  new RelativeDate(mp.utility.to_localized_date(Date.today()).addDays(5)); // 5 days from now
     *  var yesterday = new RelativeDate(-1);
     */
  var RelativeDate = function(date) {
    if (date instanceof Date) {
      var today_ms = to_date(localize_date(new Date)).getTime();
      var date_ms = to_date(date).getTime();
      var difference_ms = date_ms - today_ms;
      var one_day_in_ms = 1000 * 60 * 60 * 24;

      // round away any DST errors
      this.value = Math.round(difference_ms / one_day_in_ms);
    } else {
      this.value = date;
    }
  };

    /**
     * Convert the relative date into a localized Date instance
     */
  RelativeDate.prototype.to_date = function() {
    return localize_date(new Date).addDays(this.value);
  };

  /**
     * Convert the relative date to a localized date string
     */
  RelativeDate.prototype.toString = function(format) {
    return this.to_date().toString(format || default_date_format);
  };

  /**
     * Compares two relative dates and returns true if they are equal
     *
     * This also will compare this relative date with a regular date
     */
  RelativeDate.prototype.equals = function(other) {
    return this.to_date().equals(to_date(other));
  };

  /**
     * Constructor accepts multiple forms:
     *
     * // make a labeled date range from two dates
     * var d_range = DateRange(Date.today(), Date.today().addDays(5), "label");
     *
     * // make an unlabeled date range from two dates
     * var d_range = DateRange(Date.today(), Date.today().addDays(5));
     *
     * // make an labeled date range from one date (uses today as the other date)
     * var d_range = DateRange(Date.today().addDays(-1), "label");
     *
     * // make an unlabeled date range from one date (uses today as the other date)
     * var d_range = DateRange(Date.today().addDays(-1));
     *
     * You can also pass in RelativeDates instead of Dates for either
     * argument
     */
  var DateRange = function(from, to, label) {
    this._from = from;
    this._to = to;
    this._label = label;

    if (arguments.length < 3) {
      if (!(this._to instanceof RelativeDate || this._to instanceof Date)) {
        this._label = to;
        this._to = localize_date(new Date);
      } else if (!this._to) {
        this._to = localize_date(new Date);
      }
    }

    if (_.isString(this._from)) { this._from = Date.parse(this._from); }
    if (_.isString(this._to)) { this._to = Date.parse(this._to); }
  };

  DateRange.prototype.from = function() { return to_date(this._from); };
  DateRange.prototype.to = function() { return to_date(this._to); };

  DateRange.prototype.relative_from = function() {
    return (new RelativeDate(to_date(this._from))).value;
  };
  DateRange.prototype.relative_to = function() {
    return (new RelativeDate(to_date(this._to))).value;
  };

  DateRange.prototype.label = function(format) {
    return this._label || this.toString(format);
  };

  DateRange.prototype.get_raw_label = function() {
    return this._label;
  };

  DateRange.prototype.toString = function(format, separator) {
    format = format || `MMMM dS, yyyy`;
    return _.sprintf(`%s - %s`, this.from().toString(format), this.to().toString(format));
  };

  DateRange.prototype.equals = function(other_date_range) {
    return (
      this.from().equals(other_date_range.from())
            && this.to().equals(other_date_range.to())
    );
  };

  DateRange.prototype.days = function() {
    // from_date=2000-01-01 means "beginning of jan 1st"
    // but to_date=2000-01-01 means "end of jan 1st"
    // so we add a day to the difference
    return Math.round((this.to() - this.from()) / 86400000) + 1;
  };

  DateRange.prototype.to_date_array = function() {
    var cur = this.from().clone();
    var dates = [];
    while (cur < this.to()) {
      dates.push(cur.addDays(1));
      cur = cur.clone();
    }
    return dates;
  };

  window.RelativeDate = RelativeDate;
  window.DateRange = DateRange;
}());

}.call(window));